<div class="flex gap-4">
  <div class="w-1/3">
    <form [formGroup]="valueForm">
      <app-input-group>
        <label appLabel>{{ 'meteringpoint.timeseries.submit.estimationmethod' | translate }}</label>
        <select appSelect [collection]="estimationMethods" formControlName="estimationMethod"></select>
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'common.date.start' | translate }}</label>
        <input appInputDate formControlName="start" />
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'common.date.end' | translate }}</label>
        <input appInputDate formControlName="end" />
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'meteringpoint.timeseries.submit.periodusage' | translate }}</label>
        <input type="number"
               appInput
               formControlName="periodUsage"
        />
      </app-input-group>
    </form>

    <form [formGroup]="form">
      @if (shouldShowElement('resolution')) {
        <app-input-group>
          <label appLabel>{{ 'meteringpoint.timeseries.submit.resolution' | translate }}</label>
          <select appSelect formControlName="resolution" [collection]="resolutionList">
          </select>
        </app-input-group>
      }
      @if (shouldShowElement('otherMeteringPoint')) {
        <app-input-group>
          <label appLabel>{{ 'meteringpoint.identification' | translate }}</label>
          <input
            type="text"
            appInput
            formControlName="otherMeteringPoint"
            [placeholder]="'meteringpoint.identification' | translate"
          >
        </app-input-group>
      }
      @if (shouldShowElement('quantityQuality')) {
        <app-input-group>
          <label appLabel>{{ 'meteringpoint.timeseries.submit.quantityquality' | translate }}</label>
          <select appSelect formControlName="quantityQuality" [collection]="quantityQuality">
          </select>
        </app-input-group>
      }
      @if (shouldShowElement('unitType')) {
        <app-input-group>
          <label appLabel>{{ 'meteringpoint.timeseries.submit.unittype' | translate }}</label>
          <select appSelect formControlName="unitType" [collection]="unitType">
          </select>
        </app-input-group>
      }
      @if (shouldShowElement('wantsDataLocked')) {
        <app-input-group>
          <label appLabel>{{ 'meteringpoint.timeseries.submit.wantslocked' | translate }}</label>
          <select appSelect formControlName="wantsDataLocked">
            <option [value]="false">{{ 'common.no' | translate }}</option>
            <option [value]="true">{{ 'common.yes' | translate }}</option>
          </select>
        </app-input-group>
      }
    </form>
    @if (shouldShowElement('distributeValues')) {
      <div>
        <button
          appButton
          (click)="distributeValues()"
        >
          Fordel
        </button>
      </div>
    }
  </div>

  @if (shouldShowElement('intervalFields')) {
    <div class="w-2/3 border-l border-gray-200 pl-4 relative">
      @if (valueForm.get('estimationMethod')?.value !== EstimationMethod.ManualEvenly && valueForm.get('estimationMethod')?.value !== EstimationMethod.ManualLastPosition && valueForm.get('estimationMethod')?.value !== EstimationMethod.ManualAdvancedVEE) {
        <!-- Overlay -->
        <div class="absolute top-0 right-0 left-0 bottom-0 opacity-60 bg-white cursor-not-allowed z-5"></div>
      }

      @if (isEstimating) {
        <!-- Loading Overlay -->
        <div class="absolute top-0 left-0 right-0 bottom-0 bg-white bg-opacity-75 flex items-center justify-center z-10">
          <div class="text-center">
            <div class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            <p class="mt-2 text-primary">{{ 'common.loading' | translate }}</p>
          </div>
        </div>
      }

      <form [formGroup]="intervalForm">
        @if (shouldShowElement('distributeValues') && showDateRangeWarning) {
          <app-alert type="info">
            {{ 'meteringpoint.timeseries.submit.invaliddaterange' | translate }}
          </app-alert>
        }
        <table class="bg-gray-100 dark:bg-dark-hover border-collapse table-fixed w-full overflow-hidden rounded-t-md" [class.hidden]="shouldShowElement('distributeValues') && showDateRangeWarning">
          <thead>
          <tr>
            <th class="w-1/4 bg-gray-100 dark:bg-dark-hover px-2 py-1 rounded-t text-sm text-left font-normal text-primary dark:text-dark-text border-slate-200 dark:border-dark-border first-of-type:border-l border-r border-b border-t">Interval</th>
            @for (col of columns; track col) {
              <th class="bg-gray-100 dark:bg-dark-hover px-2 py-1 rounded-t text-sm text-left font-normal text-primary dark:text-dark-text border-slate-200 dark:border-dark-border first-of-type:border-l border-r border-b border-t">{{ col }}</th>
            }
          </tr>
          </thead>
          <tbody>
            @for (item of intervalArray; track item; let i = $index) {
              <tr class="odd:bg-white dark:odd:bg-dark-card even:bg-gray-50 dark:even:bg-dark-hover">
                <td class="text-primary dark:text-dark-text font-normal text-sm py-1 px-2 border-slate-200 dark:border-dark-border first-of-type:border-l truncate border-r border-b">
                  {{ i < 10 ? '0' + i : i }} - {{ (i + 1) < 10 ? '0' + (i + 1) : (i + 1) }}
                </td>
                @for (col of columns; track col; let j = $index) {
                  <td class="text-primary dark:text-dark-text py-1 px-2 border-slate-200 dark:border-dark-border first-of-type:border-l truncate border-r border-b">
                    <input type="number" class="!min-w-12" appInput step="0.1" [formControlName]="formatFormControlName(item[j])" />
                  </td>
                }
              </tr>
            }
          </tbody>
          @if (shouldShowElement('distributeValues')) {
            <tfoot>
              <tr class="bg-gray-100 dark:bg-dark-hover">
                <td class="text-primary dark:text-dark-text font-medium text-sm py-2.5 px-2 border-slate-200 dark:border-dark-border first-of-type:border-l border-r border-t-2 border-b">
                  {{ 'common.sum' | translate }}
                </td>
                @for (col of columns; track col; let j = $index) {
                  <td class="text-primary dark:text-dark-text font-medium text-sm py-2.5 px-2 border-slate-200 dark:border-dark-border border-r border-t-2 border-b">
                    {{ getColumnSum(j) | number:'1.0-4':'da' }}
                  </td>
                }
              </tr>
            </tfoot>
          }
        </table>
        <div>
          <a href="#" class="flex underline text-gray-400 text-sm py-4" (click)="$event.preventDefault(); populateDistribution(0)">{{ 'meteringpoint.timeseries.submit.clearintervals' | translate }}</a>
        </div>
      </form>
    </div>
  }
</div>
